



































import { Vue, Prop, Component } from "vue-property-decorator"

@Component({})
export default class CreateRecipeIngredientsList extends Vue {
	@Prop({ required: true }) recipe!: RecipeObject;

	deleteIngredient(index: number) {
		this.$root.$emit("delete-ingredient", index)
	}

	addIngredient() {
		this.$root.$emit("add-ingredient")
	}
}
